// The LV match columns element types and cable types share.
export const LV_MATCH_COLUMNS = [
  "lvMatchId",
  "lvMatchName",
  "lvMatchReasoning",
] as const;
